angular.module('dpw.directives').directive('dpwFreeExtensionInvitation', [function () {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'dpw-free-extension-invitation.directive.html',
        controllerAs: 'ctrl',
        controller: ['$scope', '$q', 'GoogleRecaptcha', 'freeExtensionService', 'popupUtil', 'trackUtil', 'mixpanelService', 'organizationService', 'developerService', 'dpwAppAccessService', function ($scope, $q, GoogleRecaptcha, freeExtensionService, popupUtil, trackUtil, mixpanelService, organizationService, developerService, dpwAppAccessService) {
            var self = this;

            self.$onInit = function () {
                self.googleRecaptcha = new GoogleRecaptcha('google-recaptcha');
                self.model = {};
            };

            $scope.rolePermissionConfig = {
                shouldDisplayErrorIfAny: false,
                extraClass: 'manage-role-and-app-access-invite-new-user',
                onChange: function (data) {
                    self.model.role = data.userRoleId;
                    self.model.toWriteApps = _.compact(_.map(data.appAccessSettings, function (appAccess, appId) {
                        if (appAccess === dpwAppAccessService.AppAccess.ReadWrite) {
                            return appId;
                        }
                    }));
                }
            };

            self.close = function () {
                $scope.config.close();
            };

            self.sendInvitation = function () {

                trackUtil.logPageView('FreeExtensionInvitation:ButtonClicked');

                var userResponse = self.googleRecaptcha.getResponse();

                setFieldTouched('email');
                $scope.rolePermissionConfig.shouldDisplayErrorIfAny = true;

                if (getForm().$invalid || !userResponse || !self.model.role) {
                    scrollToError();
                    return;
                }

                var data = {
                    email: self.model.email,
                    googleRecaptcha: self.googleRecaptcha.getResponse(),
                    role: self.model.role,
                    toWriteApps: self.model.toWriteApps
                };

                self.trackOnMixpanel();

                freeExtensionService.sendInvitation(data)
                    .then(onSuccess)
                    .catch(onError);
            };

            self.isFieldInvalid = function (fieldName, errorType) {
                var isFieldInvalid = _.get(getForm(), [fieldName, '$error', errorType]);
                var isFieldTouched = _.get(getForm(), [fieldName, '$touched']);
                return isFieldInvalid && isFieldTouched;
            };

            self.getMessage = function (code) {
                return RCDPW.Lang.FreeSignUpInvitation[code];
            };

            self.markFieldInvalid = function (fieldName, errorType) {
                var fieldCtrl = _.get(getForm(), fieldName);

                if (fieldCtrl) {
                    fieldCtrl.$setValidity(errorType, false);

                    var deRegister = $scope.$watch(['ctrl.model', fieldName].join('.'),
                        function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                fieldCtrl.$setValidity(errorType, true);
                                deRegister();
                            }
                        }
                    );
                }
            };

            self.performJqValidate = (function () {
                var validationConfig = {
                    email: {
                        name: 'emailFormatWithJqValidate',
                        validator: $.validator.methods.customEmailWithBackList,
                        getValue: function () {
                            return self.model.email;
                        }
                    }
                };

                return function (fieldName) {
                    var config = validationConfig[fieldName];
                    var name = _.get(config, 'name');
                    var value = _.result(config, 'getValue');
                    var validator = _.get(config, 'validator');

                    var fieldCtrl = _.get(getForm(), fieldName);
                    fieldCtrl && fieldCtrl.$setValidity(name, _.isEmpty(value) ? true : validator(value));
                };
            })();

            self.trackOnMixpanel = function () {
                $q.resolve()
                    .then(function () {
                        return organizationService.getOrganization();
                    })
                    .then(function (organization) {
                        self.organization = organization;
                        return developerService.getDeveloper();
                    })
                    .then(function (developer) {
                        self.developer = developer;
                    })
                    .then(function () {
                        mixpanelService.track(mixpanelService.eventNames.INVITE_NEW_USER);
                    });
            };

            function onSuccess() {
                $scope.config.close();
                trackUtil.logPageView('FreeExtensionInvitation:Success');
                popupUtil.ok({
                    title: ' ',
                    content: 'The invitation email has been sent out successfully!'
                });
            }

            function onError(params) {
                self.googleRecaptcha.reset();
                trackUtil.logPageView('FreeExtensionInvitation:Fail');
                var errorHandlerConfig = {
                    'INVALID_EMAIL_ADDRESS': function () {
                        self.markFieldInvalid('email', 'emailFormatWithBackendValidation');
                    },
                    'EMAIL_NOT_UNIQ': function () {
                        self.markFieldInvalid('email', 'emailNotUniq');
                    },
                    'MAX_EXT_REACHED': function () {
                        freeExtensionService.loadMaxCount().then(function (maxCount) {
                            maxCount = parseInt(maxCount);
                            popupUtil.ok({
                                content: RCDPW.textInterpolate(
                                    RCDPW.Lang.FreeSignUp.MAX_EXT_REACHED,
                                    {maxCount: maxCount + (maxCount === 1 ? ' developer' : ' developers')}
                                ),
                                showCloseBtn: false,
                                callback: function () {
                                    $scope.config.close();
                                }
                            });
                        });
                    }
                };

                var errorCode = _.get(params.data, 'status.message');
                var errorHandler = errorHandlerConfig[errorCode];
                errorHandler ? errorHandler() : params.defaultErrorHandler();
            }

            function setFieldTouched(name) {
                getForm()[name].$setTouched();
            }

            function getForm() {
                return self.form;
            }

            function scrollToError() {
                var errorField = document.querySelector('.dpw-free-extension-invitation .ng-invalid:not(form)');
                if (errorField) {
                    errorField.scrollIntoView();
                }
            }
        }]
    };
}]);
